export const API_URLS = {
  SITE_LIST: 'web/queue/getFolder/',
  SITE: 'web/queue/getSiteDetail/',
  QUEUE: 'web/queue/getQueueConfig/',
  REQUEST_TICKET: 'web/queue/requestTicket/',
  TICKET: 'web/queue/getTicketDetail/',
  PICKUP: 'web/pickup/getPickupTagList/'
}